import React from 'react'
import Register from '../components/Register'

const RegisterPage = () => <Register />

export default RegisterPage
